import type { SingletonInstance } from '@tunein/web-utils';
import { type IStores, Stores } from 'src/common/stores';

export const stores = new Stores() as SingletonInstance<IStores, Stores>;
